import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromCompany from '../reducers/company.reducer';

export const selectCompanyState = createFeatureSelector<fromCompany.CompanyState>(
  fromCompany.companyFeatureKey
);

export const selectMyCompany = createSelector(
  selectCompanyState,
  state => state?.myCompany,
);

export const selectCompanyLoading = createSelector(
  selectCompanyState,
  state => state.loading,
);
export const selectCompanyPage = createSelector(
  selectCompanyState,
  state => state.companyPage,
);

export const selectMemberPosterView = createSelector(
  selectCompanyState,
  state => state.memberPosterView,
);
